import React, { useState, useEffect } from 'react';
import { getFilteredPrintArticles } from '../../services/PrintService';
import { PrintArticle } from '../../types/PrintArticle';
import ArticleCard from '../../../home/components/ArticleCard';
import MagazineSwiper from '../magazine-filter/MagazineFilter';
import Button from '../../../components/buttons/SimpleButton/Button';
import { useTranslations } from '../../../localization/useTranslations';

const PrintArticles: React.FC = () => {
  const [articles, setArticles] = useState<PrintArticle[]>([]);
  const [selectedMagazineId, setSelectedMagazineId] = useState<number | undefined>();
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const translations = useTranslations();
  const currentPostId = window?.currentPostId || undefined;
  const articleRelatedId = window?.printRelatedArticle || undefined;

  useEffect(() => {
    const fetchArticles = async () => {
      setIsLoading(true);
      try {
        const excludePostIds = [currentPostId, articleRelatedId].filter((id) => id !== undefined) as number[];
        const fetchedArticles = await getFilteredPrintArticles(selectedMagazineId, excludePostIds, page);
        setArticles((prev) => [...prev, ...fetchedArticles]); // Append new articles to the existing list
        setHasMore(fetchedArticles.length === 9); // Update hasMore based on fetched articles count
      } catch (error) {
        console.error('Error fetching print articles:', error);
      }
      setIsLoading(false);
    };

    fetchArticles();
  }, [selectedMagazineId, currentPostId, articleRelatedId, page]);

  const loadMoreArticles = () => {
    setPage((prev) => prev + 1);
  };

  return (
    <>
      <MagazineSwiper
        onSelectMagazine={(id) => {
          setSelectedMagazineId(id || undefined);
          setPage(1); // Reset to the first page on magazine change
          setArticles([]); // Clear existing articles on magazine change
        }}
      />

      <div className="container">
        <div className="print-articles__wrapper">
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} cardType="one-third" />
          ))}
        </div>

        {isLoading && <p>{translations?.myAccount?.loading || 'Loading...'}</p>}
        {hasMore && !isLoading && (
          <div className="print-articles__button-wrapper">
            <Button
              className=""
              size="large"
              type="primary"
              label={translations?.general?.loadMore || 'Load more'}
              onClick={loadMoreArticles}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default PrintArticles;
